import HomeHero from "./HomeHero";
import HomeLogos from "./HomeLogos";
import HomeProducts from "./HomeProducts";
import HomeAppPromo from "./HomeAppPromo";
import HomeAbout from "./HomeAbout";
import HomeWebsite from "./HomeWebsite";
import HomeKeySolutions from "./HomeKeySolutions";
import HomeFAQ from "./HomeFAQ";

const Home = () => {
  return (
    <>
      <HomeHero />
      <HomeLogos />
      <HomeProducts />
      <HomeAppPromo />
      <HomeAbout />
      <HomeWebsite />
      <HomeKeySolutions />
      <HomeFAQ />
    </>
  );
};

export default Home;
